import { render, staticRenderFns } from "./CardholderDevice.vue?vue&type=template&id=4e0a448a&"
import script from "./CardholderDevice.vue?vue&type=script&lang=js&"
export * from "./CardholderDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports